import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "../screens/home";
import { Footer } from "../screens/home";
import ContinuousBackground from "./landing/ContinuousBackground";

const LogoutLayout = () => {
  const location = useLocation();

  // Auth pages that should be rendered without wrapper
  const authPaths = [
    "/login",
    "/signup",
    "/forgotpass",
    "/reset",
    "/Login",
    "/Signup",
    "/Forgotpass",
    "/Reset",
    "/verify",
    "/Verify",
  ];
  const isAuthPage = authPaths.includes(location.pathname);

  if (isAuthPage) {
    return <Outlet />;
  }

  return (
    <>
      <ContinuousBackground>
        <div className="min-h-screen">
          <Navbar />
          <Outlet />
        </div>
      </ContinuousBackground>
      <Footer />
    </>
  );
};

export default LogoutLayout;
